
// Vue reactivity
import { computed, ref } from 'vue';

// icons
import { add } from 'ionicons/icons';

// components
import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent,
        IonGrid, IonSpinner, IonList, IonItem, IonLabel, IonIcon, IonThumbnail,
        IonButtons, IonButton, IonBackButton, IonBadge } from '@ionic/vue';

// API services
import { utils } from '@/composables/utils';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';

export default {
  name: 'OrderListPage',
  components: { IonHeader, IonToolbar, IonTitle, IonContent, IonPage,
                IonGrid, IonSpinner, IonList, IonItem, IonLabel, IonIcon, IonThumbnail,
                IonButtons, IonButton, IonBackButton, IonBadge, },
  setup() {
    // methods or filters
    const { t } = useI18n();
    const store = useStore();
    const { getOrderStatusColor, formatDate } = utils();

    // 1. declare state variables (ref to make them reactive)
    const loading = computed(() => store.state.loadingOrders);
    const orders = computed(() => store.state.orders);

    // 3. return variables & methods to be used in template HTML
    return {
      // icons
      add,

      // variables
      loading, orders,

      // methods
      t, formatDate, getOrderStatusColor,
    }
  }
}
